
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class OrganizeService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    list(query?: any) {
        return this.get('/organizes',query);
    }

    create(body: any) {
        return this.post('/organize',body);
    }

    find(id) {
        return this.get('/organize/'+id);
    }

    update(id, body) {
        return this.put('/organize/'+id, body);
    }

    _delete(id) {
        return this.delete('/organize/'+id);
    }

    allOrganize(query?:any) {
        return this.get('/all-organize', query);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Organize.service.ts